module.exports = __webpack_public_path__ + "img/fondo_play_icons.d68a0b91.png";